<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'债权融资管理'},{name:'融资租赁申请列表',goback:true},{name:'融资租赁公司详情'}]" :title="'融资租赁公司详情'"/>
            <!-- 产品详情 -->
            <div class="box">
              <el-card class="basic box_card" header="基本信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">公司名称：</div>
                    <div class="content">{{dataInfo.companyName||'--'}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">分类：</div>
                    <div class="content">{{dataInfo.classifyValue||'--'}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">LOGO：</div>
                    <div class="content"><img class="logos" :src="dataInfo.frontPath+dataInfo.logoUrl"></div>
                </div>
                  </el-col>
                  </el-row>
                  <el-row>
                  <el-col :span="24">
                   <div class="child">
                    <div class="name">公司简介：</div>
					<div class="content super_p">{{dataInfo.explanation||'--'}}</div>
                </div>
                  </el-col>
                  </el-row>
                  <el-row>
                  <el-col :span="24">
                    <div class="childMulti">
                    <div class="name">融资租赁说明：</div>
                    <ul>
                        <li class="content super_p">{{dataInfo.remarks||'--'}}</li>
                    </ul>
                </div>
                  </el-col>
                  </el-row>
                  <el-row>
                   <el-col :span="24">
                      <div class="attachment" v-if="dataInfo.fileList&&dataInfo.fileList.length>0">
                    <div class="name">附件：</div>
                    <ul class="content">
                        <li v-for="(i,index) in dataInfo.fileList" :key="index"><span>{{i.fileName}}</span>
							<i class="el-icon-download" @click="downLoad(i)"></i>
						</li>
                    </ul>
                </div>
                  </el-col>
                   <el-col :span="8">
                   
                  </el-col>
                  <el-col :span="8">

                  </el-col>
                  <el-col :span="8">

                  </el-col>
                  <el-col :span="8">

                  </el-col>
                  <el-col :span="8">
                    
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="其它信息" shadow="never">
                <el-row>
                    <el-col :span="8">
                     <div class="child">
                    <div class="name">发布账号：</div>
                    <div class="content">{{dataInfo.createUserName||'--'}}</div>
                </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                    <div class="name">发布时间：</div>
                    <div class="content">{{dataInfo.createTime||'--'}}</div>
                </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                    <div class="name">更新账号：</div>
                    <div class="content">{{dataInfo.modifyUserName||'--'}}</div>
                </div>
                    </el-col>
                    <el-col :span="8">
                     <div class="child">
                    <div class="name">更新时间：</div>
                    <div class="content">{{dataInfo.updateTime||'--'}}</div>
                </div>
                    </el-col>
                  </el-row>
              </el-card>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            id:"",//详情
			dataInfo:'',
        }
    },
    methods:{
		getDetail(){
			this.$axiosz.get('rpc/financial/leasing/details/'+this.id).then((r)=>{
			    if(r.code==200){
			        this.dataInfo=r.data;
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
        //下载附件
        downLoad:function({fileName,filePath}){
          // window.open(url)
          const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
      },
    },
    created(){
        if(this.$route.query.id){
            this.id=this.$route.query.id;
			this.getDetail();
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:100%;
    padding:0;
    overflow: hidden;
    background: transparent !important;
    .detailBas{
        padding-top: 20px;
        border-top:1px solid rgba(112, 112, 112, 0.1);
    }
}
.box{
    height:calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding: 14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding: 24px 25px !important;
        }
      }
    }
    .childMulti{
      margin-top:0 !important;
    }
    .child{
        margin-bottom: 10px;
    }
}
.basisTitle{
    margin-bottom: 10px;
}
.super_p{
  line-height: 24px !important;
}
</style>